import React from 'react';
import YesIcon from '../../../../Assets/Prepratory/picsvg_download (17).svg';
import SometimesIcon from '../../../../Assets/Prepratory/picsvg_download (18).svg';
import NoIcon from '../../../../Assets/Prepratory/picsvg_download (19).svg';
import NotSureIcon from '../../../../Assets/Prepratory/picsvg_download (20).svg';

/**
 * A simple emoji face component for the reflection responses
 * Uses img tags instead of ReactComponent for PDF compatibility
 */
const ReflectionEmoji = ({ type, selected }) => {
    let iconSrc;
    switch (type) {
        case 'Yes':
            iconSrc = YesIcon;
            break;
        case 'To an extent':
            iconSrc = SometimesIcon;
            break;
        case 'No':
            iconSrc = NoIcon;
            break;
        case 'Not sure':
            iconSrc = NotSureIcon;
            break;
        default:
            return null;
    }

    return (
        <div style={{
            width: '32px',
            height: '32px',
            margin: '0 auto',
            borderRadius: '9999px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: selected ? '3px solid #F97316' : '2px solid #D1D5DB',
            backgroundColor: selected ? '#FEF3C7' : '#F3F4F6',
            opacity: selected ? 1 : 0.5
        }}>
            <img src={iconSrc} alt={type} style={{ width: '24px', height: '24px' }} />
        </div>
    );
};

/**
 * Main SelfAssessmentPage component
 */
const SelfAssessmentPage = ({ assignment }) => {
    // Safely extract data from the assignment
    const safeData = assignment?.self_assessment || {};
    const selfReflection = safeData.self_reflection || {};
    const learnings = safeData.learnings || {};
    const progressGrid = safeData.progress_grid || {};

    // Extract statements from each category in the progress grid
    const awarenessStatements = progressGrid.awareness || [];
    const sensitivityStatements = progressGrid.sensitivity || [];
    const creativityStatements = progressGrid.creativity || [];

    // Count statements for each category
    const awarenessCount = awarenessStatements.length;
    const sensitivityCount = sensitivityStatements.length;
    const creativityCount = creativityStatements.length;

    return (
        <div className="report-page relative font-[poppins] bg-white" style={{
            width: '210mm',
            height: '297mm',
            padding: '15mm 20mm',
            margin: '0 auto',
            fontSize: '10pt',
            lineHeight: '1.6', // Increased line-height for more vertical space
            color: '#333333',
            boxSizing: 'border-box',
            overflow: 'hidden',
            position: 'relative',
            breakInside: 'avoid',
            pageBreakInside: 'avoid',
            '@media print': {
                margin: 0,
                padding: '15mm 20mm',
                boxShadow: 'none',
                width: '210mm',
                height: '297mm'
            }
        }}>
            {/* Orange corner triangles */}
            <div className="absolute top-0 right-0 w-0 h-0"
                style={{
                    borderTop: '80px solid #f1905b',
                    borderLeft: '80px solid transparent'
                }}>
            </div>
            <div className="absolute bottom-0 left-0 w-0 h-0"
                style={{
                    borderBottom: '80px solid #F97316',
                    borderRight: '80px solid transparent'
                }}>
            </div>
            {/*/!* Orange corner decorations *!/*/}
            {/*<div className="absolute top-0 right-0 w-20 h-20 bg-orange-500"*/}
            {/*     style={{clipPath: 'polygon(100% 0, 0 0, 100% 100%)'}}/>*/}
            {/*<div className="absolute bottom-0 left-0 w-20 h-20 bg-orange-200"*/}
            {/*     style={{clipPath: 'polygon(0 100%, 0 0, 100% 100%)'}}/>*/}
            {/*<div className="absolute bottom-0 right-0 w-20 h-20 bg-orange-300"*/}
            {/*     style={{clipPath: 'polygon(100% 0, 0 100%, 100% 100%)'}}/>*/}

            {/* Header */}
            <div className="w-full border border-black text-sm bg-white">
                <div
                    className="bg-orange-400 text-center font-bold text-lg p-2 mb-3 relative z-10 ">
                    STUDENT'S SELF REFLECTION
                </div>

                {/* Self Reflection Section */}
                <div className="mb-4 p-2 relative z-10">
                    <p className="text-sm mb-2">Based on your experience of the activity, please circle the response
                        that is
                        applicable.</p>
                    <table className="w-full border-2 border-orange-300">
                        <tbody>
                            <tr className="border-b-2 border-orange-200">
                                <td className="border-r-2 border-orange-200 p-3 text-sm" style={{ width: '50%' }}>I am proud
                                    of
                                    myself and my effort.
                                </td>
                                <td className="p-1 text-center border-r-2 border-orange-200" style={{ width: '12.5%' }}>
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="Yes" selected={selfReflection.proud_of_effort === 'Yes'} />
                                        <div className="text-xs mt-1">Yes</div>
                                    </div>
                                </td>
                                <td className="p-1 text-center border-r-2 border-orange-200" style={{ width: '12.5%' }}>
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="To an extent"
                                            selected={selfReflection.proud_of_effort === 'To an extent'} />
                                        <div className="text-xs mt-1">To an extent</div>
                                    </div>
                                </td>
                                <td className="p-1 text-center border-r-2 border-orange-200" style={{ width: '12.5%' }}>
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="No" selected={selfReflection.proud_of_effort === 'No'} />
                                        <div className="text-xs mt-1">No</div>
                                    </div>
                                </td>
                                <td className="p-1 text-center" style={{ width: '12.5%' }}>
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="Not sure"
                                            selected={selfReflection.proud_of_effort === 'Not sure'} />
                                        <div className="text-xs mt-1">Not sure</div>
                                    </div>
                                </td>
                            </tr>
                            <tr className="border-b-2 border-orange-200">
                                <td className="border-r-2 border-orange-200 p-3 text-sm">I will be able to apply what I
                                    learnt
                                    from this activity to real life situations.
                                </td>
                                <td className="p-2 text-center border-r-2 border-orange-200">
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="Yes" selected={selfReflection.apply_to_real_life === 'Yes'} />
                                        <div className="text-xs mt-1">Yes</div>
                                    </div>
                                </td>
                                <td className="p-2 text-center border-r-2 border-orange-200">
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="To an extent"
                                            selected={selfReflection.apply_to_real_life === 'To an extent'} />
                                        <div className="text-xs mt-1">To an extent</div>
                                    </div>
                                </td>
                                <td className="p-2 text-center border-r-2 border-orange-200">
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="No" selected={selfReflection.apply_to_real_life === 'No'} />
                                        <div className="text-xs mt-1">No</div>
                                    </div>
                                </td>
                                <td className="p-2 text-center">
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="Not sure"
                                            selected={selfReflection.apply_to_real_life === 'Not sure'} />
                                        <div className="text-xs mt-1">Not sure</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="border-r-2 border-orange-200 p-3 text-sm">I am motivated to learn further
                                    about
                                    the
                                    concepts covered in the activity.
                                </td>
                                <td className="p-2 text-center border-r-2 border-orange-200">
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="Yes"
                                            selected={selfReflection.motivated_to_learn_more === 'Yes'} />
                                        <div className="text-xs mt-1">Yes</div>
                                    </div>
                                </td>
                                <td className="p-2 text-center border-r-2 border-orange-200">
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="To an extent"
                                            selected={selfReflection.motivated_to_learn_more === 'To an extent'} />
                                        <div className="text-xs mt-1">To an extent</div>
                                    </div>
                                </td>
                                <td className="p-2 text-center border-r-2 border-orange-200">
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="No"
                                            selected={selfReflection.motivated_to_learn_more === 'No'} />
                                        <div className="text-xs mt-1">No</div>
                                    </div>
                                </td>
                                <td className="p-2 text-center">
                                    <div className="flex flex-col items-center">
                                        <ReflectionEmoji type="Not sure"
                                            selected={selfReflection.motivated_to_learn_more === 'Not sure'} />
                                        <div className="text-xs mt-1">Not sure</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Progress Grid Section */}
                <div className="mb-4 p-2 relative z-10">
                    <div className="bg-orange-200 text-center font-bold py-2 mb-2 border-2 border-gray-400">
                        My Progress Grid
                    </div>
                    <p className="text-sm mb-2">Below are a few statements. Read each one of them carefully and circle
                        the
                        ones which are true based on your performance on the activity.</p>

                    <table className="w-full border-2 border-gray-400">
                        <thead>
                            <tr>
                                <th className="bg-pink-200 text-center font-bold py-2 border-2 border-gray-400 w-1/3">Awareness</th>
                                <th className="bg-yellow-100 text-center font-bold py-2 border-2 border-gray-400 w-1/3">Sensitivity</th>
                                <th className="bg-blue-100 text-center font-bold py-2 border-2 border-gray-400 w-1/3">Creativity</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border-2 border-gray-400 p-2 text-xs align-top">
                                    {awarenessStatements.map((statement, index) => (
                                        <div key={`awareness-${index}`}
                                            className="p-2 text-xs bg-pink-50 mb-1 border border-pink-200 rounded min-h-[2em] flex items-center">
                                            {statement}
                                        </div>
                                    ))}
                                </td>
                                <td className="border-2 border-gray-400 p-2 text-xs align-top">
                                    {sensitivityStatements.map((statement, index) => (
                                        <div key={`sensitivity-${index}`}
                                            className="p-2 text-xs bg-yellow-50 mb-1 border border-yellow-200 rounded min-h-[2em] flex items-center">
                                            {statement}
                                        </div>
                                    ))}
                                </td>
                                <td className="border-2 border-gray-400 p-2 text-xs align-top">
                                    {creativityStatements.map((statement, index) => (
                                        <div key={`creativity-${index}`}
                                            className="p-2 text-xs bg-blue-50 mb-1 border border-blue-200 rounded min-h-[2em] flex items-center">
                                            {statement}
                                        </div>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="3" className="border-2 border-gray-400 p-1 text-xs italic text-center">(For Teacher's Use Only)</td>
                            </tr>
                            <tr className="bg-gray-50">
                                <td className="border-2 border-gray-400 p-2 text-xs">
                                    <div>No. of statements circled for Awareness: <span
                                        className="font-bold">{awarenessCount}</span>
                                    </div>
                                </td>
                                <td className="border-2 border-gray-400 p-2 text-xs">
                                    <div>No. of statements circled for Sensitivity: <span
                                        className="font-bold">{sensitivityCount}</span>
                                    </div>
                                </td>
                                <td className="border-2 border-gray-400 p-2 text-xs">
                                    <div>No. of statements circled for Creativity: <span
                                        className="font-bold">{creativityCount}</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* My Learnings Section */}
                <div className="mb-3 p-2 relative z-10">
                    <div className="bg-orange-200 text-center font-bold py-2 mb-2 border-2 border-gray-400">
                        My Learnings
                    </div>

                    <div className="mb-3">
                        <div className="flex items-baseline mb-2">
                            <div className="mr-2 text-sm">By doing this activity, I learnt</div>
                            <div className="flex-1 border-b-2 border-gray-400 py-1 min-h-[1.2em] text-sm">
                                {learnings.insights || ""}
                            </div>
                        </div>
                    </div>

                    <div className="text-xs italic text-center mb-3 text-gray-600">
                        (Use this space to write your reflections/insights from the activity)
                    </div>

                    <div className="mb-3">
                        <div className="flex items-baseline mb-2">
                            <div className="mr-2 text-sm">The most interesting thing about this activity was</div>
                            <div className="flex-1 border-b-2 border-gray-400 py-1 min-h-[1.2em] text-sm">
                                {learnings.most_interesting || ""}
                            </div>
                        </div>
                    </div>

                    <div className="flex items-baseline space-x-4">
                        <div className="flex items-baseline flex-1">
                            <div className="mr-2 text-sm">I need practice on</div>
                            <div className="flex-1 border-b-2 border-gray-400 py-1 min-h-[1.2em] text-sm">
                                {learnings.need_practice || ""}
                            </div>
                        </div>
                        <div className="flex items-baseline flex-1">
                            <div className="mr-2 text-sm">I need help with</div>
                            <div className="flex-1 border-b-2 border-gray-400 py-1 min-h-[1.2em] text-sm">
                                {learnings.need_help || ""}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Page number removed as requested */}
        </div>
    );
};

export default SelfAssessmentPage;